import debounce from 'lodash/debounce';
import findIndex from 'lodash/findIndex';

import { generateUUID } from '@lumapps/utils/string/generateUUID';

/////////////////////////////

function LikeButtonController() {
    'ngInject';

    const vm = this;

    /////////////////////////////
    //                         //
    //    Public attributes    //
    //                         //
    /////////////////////////////

    /**
     * The summary of the reactions on the current resource.
     *
     * @type {Object}
     */
    vm.reactionCounts = { total: 0, details: [] };

    /**
     * The list of the user reactions on the current resource.
     *
     * @type {Object}
     */
    vm.currentUserReactions = [];


    /////////////////////////////
    //                         //
    //    Private functions    //
    //                         //
    /////////////////////////////

    function getContentResourceType(content) {
        switch (content.type) {
            case 'post':
                return 'post';
            default:
                return 'content';
        }
    }

    /**
     * Initialize the controller.
     */
    function init() {
        vm.kind = vm.kind || 'Content';
        vm.theme = vm.theme || 'light';

        vm.resourceRef = {
            resourceId: vm.content.uid,
            resourceType: getContentResourceType(vm.content)
        };

        if (angular.isDefined(vm.content.currentUserReactions)) {
            vm.currentUserReactions = [...vm.content.currentUserReactions];
        }

        if (angular.isDefined(vm.content.reactionCounts)) {
            vm.reactionCounts = vm.content.reactionCounts;
        }

        if (angular.isUndefinedOrEmpty(vm.content.uid) && angular.isDefinedAndFilled(vm.content.id)) {
            vm.content.uid = vm.content.id;
        }
    }

    init();
}

/**
 * Display a like count and allows toggling of the like status for the current user.
 *
 * @param {Object}  content          The related content object to be liked / unliked.
 * @param {boolean} [isExtended]     Indicates if we need to display the label next to the icon or not.
 * @param {string}  [kind='Content'] The kind of the related content object.
 * @param {string}  [theme='light']  The theme to apply to the template.
 */

function LikeButtonDirective() {
    'ngInject';

    return {
        bindToController: true,
        controller: LikeButtonController,
        controllerAs: 'vm',
        replace: false,
        restrict: 'E',
        scope: {
            content: '<lsContent',
            isExtended: '<?lsIsExtended',
            kind: '@?lsKind',
            theme: '@?lsTheme',
        },
        templateUrl: '/client/front-office/modules/social/views/like-button.html',
    };
}

/////////////////////////////

angular.module('Directives').directive('lsLikeButton', LikeButtonDirective);

/////////////////////////////

export { LikeButtonDirective };
